import { IRIFormProps } from '../../../_core/form/form.types';
import { IRequest } from '../../../../lib/types';
import { IDownloadRequestAssetsParams } from '../../request/request.types';
import { ISectionData } from '../../../_editor/section/section.types';

export enum DownloadableAssetType {
  SECTION,
  UPLOAD,
  PROVIDED_DOC
}

export type IDownloadRequestAssetsFormParams = Omit<IDownloadRequestAssetsParams, 'fileName'>;

export interface IDownloadRequestAssetsFormProps extends IRIFormProps<IDownloadRequestAssetsFormParams> {
  editorData: ISectionData[];
  request: IRequest;
}

export interface IDownloadableAsset {
  name: string;
  id: string;
}

export interface ISelectableDownloadRequestAssetsGridColumn {
  onSelect?: (_: SelectedDownload) => void;
}

export interface IDownloadRequestAssetsGridColumn extends ISelectableDownloadRequestAssetsGridColumn {
  files: IDownloadableAsset[];
  selected?: SelectedDownload[];
  title: string;
  type: DownloadableAssetType;
}

export interface IDownloadRequestAssetsGridColumnItem extends ISelectableDownloadRequestAssetsGridColumn {
  ignoreIcon?: boolean;
  index?: number;
  item: IDownloadableAsset;
  selected?: boolean;
  type: DownloadableAssetType;
}

export interface SelectedDownload {
  id: string;
  index?: number;
  fileName: string;
  type: DownloadableAssetType;
}
